<div class="auth acenter">
  <div class="login-form">
    <h4>{{ 'auth.ssoNavigating' | translate }}</h4>
  </div>
</div>
